import Env from '@/env/env'
import Echo from 'laravel-echo'

class ChannelStub {
    // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-unused-vars
    listen (_event: string, _callback: Function): ChannelStub {
        return this
    }
}

class EchoStub {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    channel (_channel: string): ChannelStub {
        return new ChannelStub()
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    leave (_channel: string) {
        // noop
    }
}

let echo: Echo = new EchoStub() as Echo

if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-var-requires
    const Pusher = require('pusher-js')

    const pusher = new Pusher(Env.pusherKey, {
        cluster: 'eu'
    })
    echo = new Echo({
        broadcaster: 'pusher',
        client: pusher
    })
}

export default echo
